var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: "Thông tin bổ sung",
        "dialog-class": "sk-dialog--lg",
        "use-panel": false,
        "show-cancel": false,
        "show-confirm": false,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("Hủy")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("Lưu")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "aid-dialog",
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.formRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "div",
                { staticClass: "sk-panel aid-dialog__panel" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-user" }),
                    ]),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thông tin điểm danh bổ sung"),
                      ]),
                      _vm.studentName
                        ? _c("p", { staticClass: "sk-panel-subtitle" }, [
                            _vm._v("Học sinh: " + _vm._s(_vm.studentName)),
                          ])
                        : _vm._e(),
                      _vm.dataForm.descriptionTurn
                        ? _c("p", { staticClass: "sk-panel-subtitle" }, [
                            _vm._v(_vm._s(_vm.dataForm.descriptionTurn)),
                          ])
                        : _vm.month && _vm.year
                        ? _c("p", { staticClass: "sk-panel-subtitle" }, [
                            _vm._v(
                              "Đợt " +
                                _vm._s(_vm.turn) +
                                " - Tháng " +
                                _vm._s(_vm.month) +
                                "/" +
                                _vm._s(_vm.year)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "aid-dialog__head" }, [
                    _c("div", [_vm._v("Tiêu đề")]),
                    _c("div", [_vm._v("Tháng " + _vm._s(_vm.month))]),
                    _c("div", [_vm._v(_vm._s(_vm.monthBeforeLabel))]),
                    _c("div", [_vm._v("Bổ sung")]),
                  ]),
                  _vm._l(_vm.metricRows, function (item) {
                    return _c(
                      "div",
                      { key: item.key, staticClass: "aid-dialog__row" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "aid-dialog__cell aid-dialog__cell--title",
                          },
                          [_vm._v(_vm._s(item.label))]
                        ),
                        _c("div", { staticClass: "aid-dialog__cell" }, [
                          _vm._v(
                            _vm._s(_vm.valueOrZero(_vm.dataForm[item.totalKey]))
                          ),
                        ]),
                        _c("div", { staticClass: "aid-dialog__cell" }, [
                          _vm._v(
                            _vm._s(
                              _vm.valueOrZero(_vm.dataForm[item.monthBeforeKey])
                            )
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "aid-dialog__cell aid-dialog__cell--edit",
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "aid-dialog__form-item",
                                attrs: { prop: item.valueKey },
                              },
                              [
                                _c("el-input-number", {
                                  staticClass: "sk-u-w-full",
                                  attrs: {
                                    min: 0,
                                    step: 1,
                                    size: "small",
                                    "controls-position": "right",
                                  },
                                  model: {
                                    value: _vm.dataForm[item.valueKey],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, item.valueKey, $$v)
                                    },
                                    expression: "dataForm[item.valueKey]",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "sk-panel aid-dialog__panel sk-u-mt-12" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--success" },
                      [_c("i", { staticClass: "el-icon-document" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Nội dung ghi chú"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Ghi chú hiển thị đồng bộ cho phiếu thu"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Ghi chú", prop: "note" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: "500",
                          "show-word-limit": "",
                          placeholder: "Nhập ghi chú bổ sung",
                        },
                        model: {
                          value: _vm.dataForm.note,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "note", $$v)
                          },
                          expression: "dataForm.note",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel aid-dialog__panel sk-u-mt-12" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                      [_c("i", { staticClass: "el-icon-time" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thời gian tính toán áp dụng"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Thời gian tính toán ghi nhận từ hệ thống (không thể chỉnh sửa)"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "span",
                          {
                            staticClass: "sk-form-item-group-label",
                            staticStyle: {
                              "font-weight": "600",
                              "font-size": "13px",
                              color: "#1e293b",
                              display: "block",
                              "margin-bottom": "8px",
                            },
                          },
                          [
                            _vm._v(
                              "\n              Thời gian tính trước\n              "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "Thời gian tính trước dùng để tính theo lịch học",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-question tdi-help-icon ml-1",
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "#909399",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Từ ngày" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  type: "date",
                                  disabled: "",
                                  "value-format": "yyyy-MM-dd",
                                  format: "dd-MM-yyyy",
                                },
                                model: {
                                  value: _vm.dataForm.preCalcStartDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "preCalcStartDate",
                                      $$v
                                    )
                                  },
                                  expression: "dataForm.preCalcStartDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Đến ngày" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  type: "date",
                                  disabled: "",
                                  "value-format": "yyyy-MM-dd",
                                  format: "dd-MM-yyyy",
                                },
                                model: {
                                  value: _vm.dataForm.preCalcEndDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "preCalcEndDate",
                                      $$v
                                    )
                                  },
                                  expression: "dataForm.preCalcEndDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "sk-u-mt-12", attrs: { gutter: 12 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "span",
                          {
                            staticClass: "sk-form-item-group-label",
                            staticStyle: {
                              "font-weight": "600",
                              "font-size": "13px",
                              color: "#1e293b",
                              display: "block",
                              "margin-bottom": "8px",
                            },
                          },
                          [
                            _vm._v(
                              "\n              Thời gian tính sau\n              "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "Thời gian tính sau dùng để tính dựa trên dữ liệu điểm danh thực tế",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-question tdi-help-icon ml-1",
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "#909399",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Từ ngày" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  type: "date",
                                  disabled: "",
                                  "value-format": "yyyy-MM-dd",
                                  format: "dd-MM-yyyy",
                                },
                                model: {
                                  value: _vm.dataForm.postCalcStartDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "postCalcStartDate",
                                      $$v
                                    )
                                  },
                                  expression: "dataForm.postCalcStartDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Đến ngày" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  type: "date",
                                  disabled: "",
                                  "value-format": "yyyy-MM-dd",
                                  format: "dd-MM-yyyy",
                                },
                                model: {
                                  value: _vm.dataForm.postCalcEndDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "postCalcEndDate",
                                      $$v
                                    )
                                  },
                                  expression: "dataForm.postCalcEndDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel aid-dialog__panel sk-u-mt-12" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--primary" },
                      [_c("i", { staticClass: "el-icon-date" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Khoảng thời gian áp dụng"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Khoảng thời gian phiếu thu có hiệu lực (không thể chỉnh sửa)"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Từ ngày" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  type: "date",
                                  disabled: "",
                                  "value-format": "yyyy-MM-dd",
                                  format: "dd-MM-yyyy",
                                },
                                model: {
                                  value: _vm.dataForm.startValidityPeriod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "startValidityPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "dataForm.startValidityPeriod",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Đến ngày" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  type: "date",
                                  disabled: "",
                                  "value-format": "yyyy-MM-dd",
                                  format: "dd-MM-yyyy",
                                },
                                model: {
                                  value: _vm.dataForm.endValidityPeriod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "endValidityPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "dataForm.endValidityPeriod",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }